import {
  customReservedInventoryBucketTypeIdFormat,
  locationIdFormat,
  productIdFormat,
} from "@redotech/redo-model/ids";
import * as z from "zod";

export const getReservedInventoryBuckets = {
  name: "getReservedInventoryBuckets" as const,
  input: z.object({
    productId: productIdFormat.schema,
    locationId: locationIdFormat.schema,
  }),
  output: z.object({
    buckets: z.array(
      z.object({
        kind: z.string().nullable(),
        customTypeId:
          customReservedInventoryBucketTypeIdFormat.schema.nullable(),
        customTypeName: z.string().nullable(),
        quantity: z.number(),
        imsQuantity: z.number(),
        wmsQuantity: z.number(),
        totalQuantity: z.number(),
      }),
    ),
  }),
};
